import { SPACING } from "./layout";

export const CARD_BASE = "surface-card text-card-foreground rounded-lg border";

export const CARD_PADDED = `${CARD_BASE} ${SPACING.CARD_PADDING}`;

export const SECTION_HEADER = "border-b border-border";
export const CARD_HEADER_BG = "surface-panel";

export const SECTION_TITLE = "text-sm font-semibold leading-tight text-foreground";

export const PAGE_TITLE = "truncate text-lg font-semibold leading-tight text-foreground sm:text-xl";

export const TITLE_PAGE_LARGE = "text-lg font-semibold tracking-tight text-foreground sm:text-xl";

export const SECTION_SUBTITLE = "mt-0.5 text-xs text-muted-foreground";

export const SECTION_LABEL = "text-xs font-semibold uppercase tracking-wide text-muted-foreground";

export const LABEL_SM = "text-[9px] font-semibold uppercase tracking-wide text-muted-foreground";

export const META_ROW_BASE = `surface-card flex items-center gap-1 rounded-lg border ${SPACING.CARD_PADDING}`;

export const BOX_MUTED = `surface-card rounded-lg border ${SPACING.CARD_PADDING}`;

export const BOX_MUTED_50 = `surface-card rounded-lg border ${SPACING.CARD_PADDING}`;

export const BOX_MUTED_50_MD = `surface-card rounded-lg border ${SPACING.CARD_PADDING}`;

export const BOX_MUTED_50_SM = `surface-card rounded-lg border ${SPACING.CARD_PADDING}`;

export const META_ROW_FLEX = `surface-card flex flex-wrap items-center justify-between gap-1 rounded-lg border ${SPACING.CARD_PADDING}`;

export const BOX_MUTED_FULL = `surface-card rounded-lg border ${SPACING.CARD_PADDING}`;

export const BOX_MUTED_MD = `surface-card rounded-md border ${SPACING.CARD_PADDING}`;

export const BOX_INFO = `rounded-lg border border-border bg-info/10 ${SPACING.CARD_PADDING}`;

export const BOX_SUCCESS = `rounded-lg border border-border bg-success/10 ${SPACING.CARD_PADDING}`;

export const BOX_SUCCESS_SM = `rounded-lg border border-border bg-success/10 ${SPACING.CARD_PADDING}`;

export const BOX_DESTRUCTIVE = `rounded-lg border border-destructive/30 bg-destructive/10 ${SPACING.CARD_PADDING}`;

export const BOX_WARNING = `rounded-lg border border-warning/30 bg-warning/10 ${SPACING.CARD_PADDING}`;

export const CODE_BLOCK = `surface-card overflow-auto rounded-lg border text-xs text-foreground ${SPACING.CARD_PADDING}`;

/** Prose for chat/message content: code inline padding & list indent use spacing scale. */
export const PROSE_CHAT =
  "text-sm [&_p]:my-1 [&_ul]:my-2 [&_ol]:my-2 [&_li]:my-0.5 [&_pre]:my-2 [&_pre]:overflow-x-auto " +
  "[&_code]:bg-muted [&_code]:px-1 [&_code]:py-0.5 [&_code]:rounded [&_code]:text-sm " +
  "[&_ul]:list-disc [&_ul]:pl-5 [&_ol]:list-decimal [&_ol]:pl-5";

export const EMPTY_WRAPPER = `surface-card border border-dashed text-center text-sm text-muted-foreground ${SPACING.CARD_PADDING}`;

export const EMPTY_INNER = `text-center text-muted-foreground ${SPACING.CARD_CONTENT_PADDING}`;

export const EMPTY_HINT = `rounded-lg border border-dashed border-border text-sm text-muted-foreground ${SPACING.CARD_PADDING}`;

export const INPUT_BASE =
  `surface-control w-full border rounded-md text-foreground ${SPACING.CONTROL_PAD} ` +
  "focus:outline-none focus:ring-2 focus:ring-ring/50 focus:border-ring " +
  "disabled:bg-muted disabled:text-muted-foreground";

export const INPUT_ERROR = "border-destructive focus:ring-destructive focus:border-destructive";

export const SELECT_BASE =
  `surface-control min-w-[100px] rounded-md border text-[13px] text-foreground ${SPACING.CONTROL_PAD} ` +
  "cursor-pointer hover:border-ring/60 focus:border-ring focus:outline-none focus:ring-2 focus:ring-ring/40 disabled:opacity-60 disabled:cursor-not-allowed";

export const METRIC_BADGE_BASE = `flex items-center gap-1 rounded-lg border text-[13px] font-medium ${SPACING.CARD_PADDING}`;

export const BUBBLE_USER = "bg-primary text-primary-foreground border border-primary/80 shadow-elevation1 max-w-[78%]";
export const BUBBLE_AGENT = "surface-card text-foreground border max-w-[92%]";
export const BUBBLE_AGENT_FULL = "surface-card text-foreground border w-full max-w-full";
export const BUBBLE_SYSTEM = "surface-card text-foreground border max-w-[78%]";
export const BADGE_PILL_BASE = "rounded-full border text-xs font-semibold uppercase tracking-wide";

export const METRIC_BADGE_VARIANT = {
  success: "border-success/30 bg-success/15 text-success dark:border-success/35 dark:bg-success/20 dark:text-success",
  warning: "border-warning/30 bg-warning/15 text-warning dark:border-warning/35 dark:bg-warning/20 dark:text-warning",
  danger: "border-destructive/30 bg-destructive/15 text-destructive dark:border-destructive/35 dark:bg-destructive/20 dark:text-destructive",
  info: "border-info/30 bg-info/15 text-info dark:border-info/35 dark:bg-info/20 dark:text-info",
  default: "border-border bg-muted text-muted-foreground dark:border-border dark:bg-muted dark:text-muted-foreground",
} as const;

export const KPI_METRIC_CARD_BASE =
  "surface-card-metric flex h-full min-h-[4rem] min-w-0 flex-col items-center justify-center rounded-lg p-3 text-center " +
  "transition-colors hover:border-ring/40 focus:outline-none focus:ring-2 focus:ring-ring/40";

export const KPI_METRIC_CARD_VARIANT = {
  default: "hover:border-ring/40",
  danger: "border-destructive/40 bg-destructive/5 hover:bg-destructive/10",
  warning: "border-warning/40 bg-warning/5 hover:bg-warning/10",
  success: "border-success/40 bg-success/5 hover:bg-success/10",
  info: "border-info/40 bg-info/5 hover:bg-info/10",
} as const;

export const KPI_VALUE = "text-xl font-semibold tabular-nums text-foreground";
export const KPI_LABEL = "text-xs text-muted-foreground mt-0.5";

export const METRIC_KPI_CARD =
  "surface-card-metric flex h-full min-h-[4rem] min-w-0 flex-col justify-center rounded-lg p-3 text-left";

/** Legacy card/table frame — prefer `LIST_TABLE_*` from `@/lib/constants/workspace-styles` on platform lists. */
export const LIST_TABLE_FRAME =
  "table-surface-frame min-h-0 min-w-0 overflow-auto rounded-md border";

export const LIST_TABLE_TD = "px-3 py-2";

export const TABLE_DENSE = "w-full text-sm";
export const TABLE_MIN_WIDTH_LG = "min-w-[980px]";
export const TABLE_MIN_WIDTH_MD = "min-w-[760px]";
export const TABLE_MIN_WIDTH_SM = "min-w-[720px]";

export const STEP_BADGE_BASE = "inline-flex items-center rounded px-1.5 py-0.5 text-[10px] font-medium uppercase tracking-wide";
export const STEP_BADGE_VARIANT = {
  done: "bg-success/20 text-success border border-success/30 dark:bg-success/25 dark:text-success dark:border-success/35",
  active: "bg-primary/15 text-primary border border-primary/30 dark:bg-primary/20 dark:text-primary dark:border-primary/40",
  pending: "bg-muted text-muted-foreground border border-border dark:bg-muted dark:text-muted-foreground dark:border-border",
} as const;

export const CAPACITY_BAR_BASE = "h-1.5 rounded-full overflow-hidden bg-muted/50 min-w-[48px]";
export const CAPACITY_BAR_FILL = {
  ok: "bg-success",
  near: "bg-warning",
  overload: "bg-destructive",
} as const;
